var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", [
      _c("h3", { staticClass: "text-center" }, [
        _vm._v("การสมัครเป็นสมาชิกของบีนีท")
      ]),
      _vm._v(" "),
      _vm.professional
        ? _c("pre", [
            _vm._v("      ข้าพเจ้า นาย/นาง/นางสาว "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(
                _vm._s(_vm.professional.title_th) +
                  " " +
                  _vm._s(_vm.professional.firstname_th) +
                  " " +
                  _vm._s(_vm.professional.lastname_th) +
                  " "
              )
            ]),
            _vm._v(" เกิดวันที่ "),
            _vm.professional.birthday &&
            _vm.professional.birthday !== "0000-00-00"
              ? _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(
                    _vm._s(_vm._f("prettyOnlyDate")(_vm.professional.birthday))
                  )
                ])
              : _vm._e(),
            _vm._v(" บัตรประจําตัวประชาชนเลขที่ "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.professional.id_card_number))
            ]),
            _vm._v(" อยู่บ้านเลขที่ "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.professional.house_no))
            ]),
            _vm._v(" ถนน "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.professional.road))
            ]),
            _vm._v(" ตําบล/แขวง "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(
                _vm._s(
                  _vm.professional.sub_district
                    ? _vm.professional.sub_district.name_th
                    : "-"
                )
              )
            ]),
            _vm._v(" อําเภอ/เขต "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(
                _vm._s(
                  _vm.professional.district
                    ? _vm.professional.district.name_th
                    : "-"
                )
              )
            ]),
            _vm._v(" จังหวัด "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(
                _vm._s(
                  _vm.professional.address_province
                    ? _vm.professional.address_province.name_th
                    : "-"
                )
              )
            ]),
            _vm._v(" หมายเลขโทรศัพท์มือถือ "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(
                _vm._s(
                  _vm.professional.phone ? "0" + _vm.professional.phone : ""
                )
              )
            ]),
            _vm._v(" E-mail (ถ้ามี) "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.professional.email) + " ")
            ]),
            _c("br"),
            _vm._v(
              "\n      กรณีเป็นนิติบุคคล ชื่อ.....เลขประจําตัวนิติบุคคลเลขที่.....สํานักงานใหญ่ตั้งอยู่ที่บ้านเลขที่.....ถนน.....ตําบล/แขวง.....อําเภอ/เขต.....จังหวัด.....โดยมีกรรมการบริษัทหรือ ผู้แทนนิติบุคล.....บัตรประจําตัวประชาชนเลขที่.....อยู่บ้านเลขที่.....ถนน.....ตําบล/แขวง.....อําเภอ/เขต.....จังหวัด.....หมายเลขโทรศัพท์มือถือ.....E-mail.....\n"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("pre", [
        _vm._v(
          "โดยที่\n    ข้าพเจ้ามีความประสงค์จะสมัครเป็นสมาชิกของบีนีท โดยมุ่งหวังที่จะได้รับการอนุมัติสถานภาพเป็นผู้ให้บริการอิสระของบีนีท ซึ่งต่อไปนี้จะเรียกว่า “ผู้ให้บริการอิสระ” กับบริษัท บีนีท จํากัด ซึ่งต่อไปนี้จะเรียกว่า “บีนีท” เพื่อให้บริการดังนี้ (กรุณาเลือกประเภทงานบริการที่สมาชิกสนใจเป็นผู้ให้บริการอิสระ)\n"
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("pre", [
        _vm._v(
          "  ตามขอบข่ายของบีนีท ซึ่งต่อไปนี้จะเรียกว่า “การให้บริการ” โดยผู้ให้บริการอิสระตกลงยินยอม\nผูกพันและปฏิบัติตามข้อตกลงและเงื่อนไขที่บีนีทกําหนด ดังต่อไปนี้\n1) การสมัครเป็นสมาชิกของบีนีทนั้น จะมีค่าสมัครสมาชิก จํานวน 500 บาท (ห้าร้อยบาทถ้วน)\n2) สมาชิกของบีนีทมีสิทธิประโยชน์ตามที่ปรากฏใน เว็บไซต์ของบีนีท หรือ บีนีทแพลตฟอร์ม\n3) สมาชิกของบีนีทมีสิทธิเข้ารับการอบรบเพื่อเป็นผู้ให้บริการอิสระของบีนีทตามประเภทการบริการ\nจํานวน 1 ครั้ง (หนึ่งครั้ง) การผ่านการอบรมดังกล่าวเป็นหนึ่งในคุณสมบัติสําคัญในการพิจารณาสถานภาพผู้ให้บริการอิสระของบีนีท ในกรณีที่สมาชิกมีความประสงค์จะเป็นผู้ให้บริการเกิน 1\nประเภทการบริการ สมาชิกจะต้องจ่ายค่าอบรมเพิ่ม 500 บาท (ห้าร้อยบาทถ้วน) ต่อหนึ่งประเภท\nกิจการ\n4) ในการคัดเลือกให้เป็นผู้ให้บริการอิสระของบีนีทตามประเภทการบริการ ผู้สมัครทราบดีว่าการเป็นผู้\nให้บริการอิสระจะต้องมีคุณสมบัติตามที่บีนีทกําหนด และจะต้องผ่านการตรวจสอบตามมาตรฐาน\nและขั้นตอนที่บีนีทกําหนดไว้ ดังนั้นสมาชิกของบีนีทอาจได้รับเลือกให้ดํารงสถานภาพเป็นผู้\nให้บริการอิสระของบีนีทหรือไม่ก็ได้\n5) ในการตรวจสอบคุณสมบัติการเป็นผู้ให้บริการอิสระจะต้องมีการตรวจสอบประวัติทางอาชญากรรม\nของผู้สมัคร ซึ่งสมาชิกอาจดําเนินการตรวจสอบเองและส่งผลการตรวจสอบให้บีนีท หรือจะให้บีนีท\nเป็นผู้ดําเนินการตรวจสอบประวัติทางอาชญากรรมของผู้สมัครก็ได้ โดยจะมีค่าใช้จ่ายตามที่บีนีท\nกําหนด\n6) สมาชิกจะต้องกรอกข้อมูลให้ครบถ้วนและรับรองว่าข้อมูลทั้งหมดที่ให้แก่บีนีทเป็นความจริงทุกประการ\n7) เพื่อประโยชน์ของทางราชการ สมาชิกตกลงยินยอมให้บีนีทตรวจสอบความถูกต้องและเปิดเผย\nข้อมูลที่ระบุไว้ในการสมัคร ทั้งนี้หากบีนีทตรวจสอบพบว่าข้อมูลที่ผู้ให้บริการอิสระระบุไว้ไม่ชัดเจน\nหรือเป็นเท็จ บีนีทมีสิทธิที่ปฏิเสธการรับลงทะเบียนสมาชิก โดยไม่ต้องแจ้งให้ท่านทราบล่วงหน้า\n8) สมาชิกรับรองตนได้อ่านข้อตกลงและเงื่อนไขการเป็นผู้ให้บริการอิสระของบีนีท ตามที่ปรากฏใน\nเว็บไซต์ www.beneat.co หรือ บีนีทแพลตฟอร์มแล้ว และเข้าใจดีว่าหากตนได้รับเลือกให้เป็นผู้ให้\nบริการอิสระของบีนีท ตนจะต้องปฏิบัติตามข้อตกลงอย่างเคร่งครัด\n"
        )
      ]),
      _vm._v(" "),
      _c("pre", [
        _vm._v(
          "ในกรณีที่สมาชิกได้รับการอนุมัติสถานภาพเป็นผู้ให้บริการอิสระ\n1) ผู้ให้บริการอิสระจะต้องกรอกข้อมูลรายละเอียดต่าง ๆ ตามจริงให้ครบถ้วน กรณีที่มีการปกปิดข้อมูล\nหรือข้อความจริงที่ควรบอกให้แจ้งแก่บีนีท กรณีตรวจพบว่าข้อมูลดังกล่าวไม่เป็นความจริง บีนีทมี\nสิทธิระงับหรือเพิกถอนสถานภาพการเป็นผู้ให้บริการอิสระโดยไม่ต้องแจ้งให้ท่านทราบล่วงหน้า\nทั้งนี้ ผู้ให้บริการอิสระจะต้องรับผิดชอบในความเสียหายที่เกิดขึ้นจากการกรอกข้อมูลอันเป็นเท็จ\nดังกล่าว\n2) เมื่อสมาชิกได้รับการอนุมัติสถานภาพการเป็นผู้ให้บริการอิสระของบีนีท บีนีทจะแจ้งให้ผู้ให้บริการ\nอิสระทราบเป็นลายลักษณ์อักษรผ่านบีนีทแพลตฟอร์มและให้ถือว่าสถานภาพการเป็นผู้ให้บริการ\nอิสระเริ่มต้นนับแต่วันที่บีนีทได้แจ้ง โดยสถานภาพการเป็นผู้ให้บริการอิสระมีอายุ 1 ปีนับจากวัน\nดังกล่าว ในการต่ออายุสถานภาพหรือการขอยกเลิกสถานภาพการเป็นผู้ให้บริการอิสระให้เป็นไป\nตามข้อตกลงการเป็นผู้ให้บริการอิสระของบีนีท\n3) เมื่อได้รับอนุมัติให้เป็นผู้ให้บริการอิสระของบีนีท ผู้ให้บริการอิสระจะต้องวางเงินประกันสถานภาพผู้\nให้บริการอิสระจํานวน 2,000 บาท (สองพันบาทถ้วน) เพื่อเป็นการประกันว่า ตนจะไม่ติดต่อกับลูกค้าหรือกระทําการอย่างใด ๆ อันเป็นเหตุในการดึงลูกค้าหรืองานบริการออกจากระบบบีนีท\nแพลตฟอร์ม\n4) ก่อนการเริ่มงานบริการ บีนีทอาจขอให้ผู้ให้บริการอิสระวางเงินประกันการทํางานตามจํานวนที่\nกําหนดเพื่อเป็นการประกันความเสียหายอย่างใด ๆ ที่เกิดขึ้นจากการทํางานของผู้ให้บริการอิสระ\nทั้งนี้ เมื่องานสิ้นสุดลงและไม่ตรวจพบหรือมีการแจ้งความชํารุดบกพร่องหรือความเสียหายจากงาน\nดังกล่าว บีนีทจะคืนเงินประกันการทํางานนั้นให้แก่ผู้ให้บริการอิสระ โดยเงื่อนไขการวางและคืนเงิน\nประกันเป็นไปตามข้อตกลงการเป็นผู้ให้บริการอิสระ\n5) ผู้ให้บริการอิสระต้องไม่นําชื่อผู้ใช้และรหัสผ่าน (Username & Password) ของท่านที่ได้รับการ\nลงทะเบียนในระบบจากบีนีทไปใช้ในทางที่ขัดต่อกฎหมาย ความสงบเรียบร้อย หรือศีลธรรมอันดี\nของประชาชนและ เพื่อประโยชน์ของทางราชการ ผู้ให้บริการอิสระตกลงยินยอมให้บีนีทตรวจสอบ\nความถูกต้องและเปิดเผยข้อมูลของผู้ให้บริการอิสระ ทั้งนี้หากบีนีทตรวจสอบพบว่าข้อมูลที่ผู้\nให้บริการอิสระบุไว้ไม่ชัดเจนหรือเป็นเท็จ บีนีทมีสิทธิที่ปฏิเสธการรับลงทะเบียนหรือยกเลิกชื่อผู้ใช้\nและรหัสผ่านของผู้ให้บริการอิสระได้ โดยไม่ต้องแจ้งให้ท่านทราบล่วงหน้า\n6) ในกรณีที่มีเหตุอันควรสงสัยว่าผู้อื่นล่วงรู้รหัสผ่าน (Password) ของผู้ให้บริการอิสระ ผู้ให้บริการ\nอิสระมีหน้าที่ตั้งรหัสผ่านใหม่ โดยทันทีผ่านทางแพลตฟอร์มออนไลน์ของบีนีท ทั้งนี้ในกรณีที่มีผู้อื่น\nนํารหัสผ่าน (Password) ไปใช้ ผู้ให้บริการอิสระต้องรับผิดชอบต่อการกระทําและความเสียหาย\nดังกล่าวด้วย\n7) เพื่อประโยชน์ในการพัฒนาหรือปรับปรุงการให้บริการ หรือเพื่อให้เป็นไปตามบทบัญญัติของ\nกฎหมายที่เกี่ยวข้อง ทั้งที่ใช้บังคับอยู่ และที่จะมีผลบังคับใช้ในอนาคต ผู้ให้บริการอิสระยินยอมให้\nบีนีทแก้ไข เปลี่ยนแปลง หรือยกเลิกข้อตกลงและเงื่อนไขการขอรับชื่อผู้ใช้และรหัสผ่าน (Username\n& Password) ได้ ตามที่บีนีทได้พิจารณาแล้วเห็นสมควร ทั้งนี้ในการแก้ไขเปลี่ยนแปลงดังกล่าว\nบีนีทจะแจ้งให้ผู้ให้บริการอิสระทราบล่วงหน้าไม่น้อยกว่า 30 วันก่อนวันที่การแก้ไข เปลี่ยนแปลง\nหรือยกเลิกข้อตกลงและเงื่อนไขจะมีผลบังคับใช้ โดยวิธีการทางอิเล็กทรอนิกส์ที่บีนีทกําหนด\n8) ผู้ให้บริการอิสระรับรองว่าจะปฏิบัติตามข้อตกลงการเป็นผู้ให้บริการอิสระของบีนีท ตามที่ปรากฏใน\nเว็บไซต์www.beneat.co หรือบีนีทแพลตฟอร์มอย่างเคร่งครัด และจะหมั่นตรวจสอบถึงการ\nเปลี่ยนแปลงข้อตกลงการเป็นผู้ให้บริการอิสระอย่างสมํ่าเสมอ\n9) ผู้ให้บริการอิสระรับทราบและเข้าใจดีว่า ในกรณีที่ข้อมูลส่วนบุคคลของผู้ให้บริการอิสระถูกโจรกรรม\nสูญหาย หรือเสียหายอันเนื่องจากเหตุสุดวิสัย หรือไม่ใช่เกิดจากความประมาทเลินเล่อ บีนีทมีสิทธิ\nปฏิเสธความรับผิดชอบในความเสียหายดังกล่าว ทั้งนี้ ผู้ใดแอบอ้างหรือกระทําการใด ๆ อันเป็นการ\nละเมิดสิทธิส่วนบุคคลโดยใช้ข้อมูลของผู้อื่นมาแอบอ้างในการสมัครขอรับชื่อผู้ใช้และรหัสผ่าน\n(Username & Password) กับบีนีท การกระทําดังกล่าวถือเป็นความผิดตามประมวลกฎหมาย\nอาญา\n10) บีนีทอาจส่งข้อมูลหรือแจ้งข่าวประชาสัมพันธ์ผ่านช่องทางอิเล็กทรอนิกส์ เช่น E-mail, SMS ให้แก่ผู้\nให้บริการอิสระได้ตามที่บีนีทเห็นสมควร\n11) บีนีทมีสิทธิระงับหรือยกเลิกการสถานภาพการเป็นผู้ให้บริการอิสระของท่านทันที หากปรากฏว่า\nท่านไม่ปฏิบัติตามข้อตกลงการเป็นผู้ให้บริการอิสระของบีนีทแม้แต่ข้อใดข้อหนึ่งโดยไม่จําเป็นต้อง\nให้เหตุผลใด ๆ\n12) บีนีทขอรับรองว่าจะใช้หรือเปิดเผยข้อมูลส่วนบุคคลของท่านเท่าที่จําเป็นเพื่อป้องกันหรือระงับ\nอันตรายต่อ ชีวิต ร่างกาย หรือสุขภาพอนามัยของท่าน ทั้งนี้ การใช้หรือเปิดเผยข้อมูลดังกล่าว\nเป็นไปตามกฎหมายว่าด้วยพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562\n13) ผู้ให้บริการอิสระตกลงให้บีนีทเก็บรวบรวมรักษา และใช้ข้อมูลของผู้ให้บริการอิสระ เพื่อประโยชน์ใน\nการให้บริการ หรือเพื่อให้เป็นไปตามกฎหมาย และกฎเกณฑ์ต่าง ๆ ที่เกี่ยวข้อง หรือเพื่อพัฒนา\nและปรับปรุงการบริการของบีนีท ให้เป็นที่พอใจแก่ลูกค้าของบีนีทและรวมไปถึงตัวผู้ให้บริการอิสระ\nเอง\n14) ผู้ให้บริการอิสระต้องรับรองและยืนยันว่าท่านได้ทําการศึกษาและเข้าใจ ข้อตกลงและเงื่อนไขการ\nเป็นผู้ให้บริการอิสระของบีนีท อย่างครบถ้วนทุกประการดีแล้ว\n\n  ข้าพเจ้าขอยืนยันและรับรองว่าในการสมัครสมาชิกบีนีทนี้ การใด ๆ ที่ข้าพเจ้าได้แสดงเจตนาไว้ใน\nแบบการลงทะเบียนเป็นความจริงและข้าพเจ้าตกลงยินยอมผูกพันเงื่อนไขการเป็นสมาชิกและการเป็นผู้\nให้บริการอิสระทุกประการ โดยข้าพเจ้าได้อ่านข้อตกลงการเป็นผู้ให้บริการอิสระของบีนีทโดยเข้าใจอย่าง\nละเอียดครบถ้วนแล้วจึงตกลงยินยอมผูกพัน และปฏิบัติตามข้อกําหนดและเงื่อนไขการเป็นผู้ให้บริการอิสระ\nของบีนีททุกประการ และรับทราบว่าการมีสถานภาพเป็นผู้ให้บริการอิสระของบีนีทจะมีผลสมบูรณ์เมื่อบีนีท\nได้แจ้งยืนยันรับรองไปยังข้าพเจ้าว่าข้าพเจ้าได้รับอนุมัติสภาพการเป็นผู้ให้บริการอิสระของบีนีทแล้วเท่านั้น\nรวมถึง ข้าพเจ้ายืนยันว่าข้าพเจ้าได้อ่านและเข้าใจรายละเอียดการขอความยินยอมข้างต้นตามที่ระบุใน\nนโยบายความเป็นส่วนตัวของบีนีทเรียบร้อยแล้ว จึงได้ลงลายมือชื่อไว้ต่อหน้าพยานเป็นสําคัญ\n"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row text-center signature-input" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 p-0" }, [
          _vm._v("\n       ลงชื่อ "),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(
              _vm._s(_vm.professional.firstname_th) +
                " " +
                _vm._s(_vm.professional.lastname_th)
            )
          ]),
          _vm._v(" สมาชิก "),
          _c("br"),
          _vm._v("\n       ( "),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(
              _vm._s(
                _vm.professional.title_th +
                  " " +
                  _vm.professional.firstname_th +
                  " " +
                  _vm.professional.lastname_th
              )
            )
          ]),
          _vm._v(" )\n     ")
        ])
      ]),
      _vm._v(" "),
      _vm._m(2)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticClass: "ml-5", staticStyle: { "list-style-type": "square" } },
      [
        _c("li", [_vm._v("การบริการทําความสะอาดต่างๆ")]),
        _vm._v(" "),
        _c("li", [_vm._v("การบริการรีดผ้า")]),
        _vm._v(" "),
        _c("li", [_vm._v("การบริการนวดแผนไทย")]),
        _vm._v(" "),
        _c("li", [_vm._v("การบริการประเภทวางท่อหรือซ่อมระบบประปา")]),
        _vm._v(" "),
        _c("li", [_vm._v("การบริการประเภทวางระบบหรือซ่อมอุปกรณ์ไฟฟ้า")]),
        _vm._v(" "),
        _c("li", [_vm._v("การบริการประเภทขนย้ายทรัพย์สิน")]),
        _vm._v(" "),
        _c("li", [_vm._v("การบริการประเภททาสี")]),
        _vm._v(" "),
        _c("li", [_vm._v("การบริการอื่นๆ")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 p-0" }, [
      _vm._v("\n       ลงชื่อ.................................."),
      _c("br"),
      _vm._v("ผู้มีอํานาจลงนามบีนีท "),
      _c("br"),
      _vm._v("\n       ( "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v("นายอานนท์ และ นางปรียลักษณ์ น้อยอ่ำ")
      ]),
      _vm._v(" )\n     ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row text-center signature-input" }, [
      _c("div", { staticClass: "col-6 p-0" }, [
        _vm._v("\n       ลงชื่อ..................................พยาน "),
        _c("br"),
        _vm._v("\n       ( "),
        _c("span", { staticClass: "font-weight-bold" }, [
          _vm._v("นางสาว ทิพาวรรณ จิวรพันธ์")
        ]),
        _vm._v(" )\n     ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 p-0" }, [
        _vm._v("\n       ลงชื่อ..................................พยาน "),
        _c("br"),
        _vm._v("\n       ( "),
        _c("span", { staticClass: "font-weight-bold" }, [
          _vm._v("นางสาว พัณษ์พิชชกร โฆวาสินธุ์")
        ]),
        _vm._v(" )\n     ")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7c719fa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7c719fa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/contract/RegisterDocument.vue
// module id = 1911
// module chunks = 0